import { Modal, ModalProps, Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';

interface ConfirmRequestJobPostingRejectModalProps extends ModalProps {
  requestJobPostingName: string;
}

const ConfirmRequestJobPostingRejectModal = ({
  requestJobPostingName,
  ...props
}: ConfirmRequestJobPostingRejectModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={
        <Typography.Text>
          <Trans>Reprovar requisição</Trans>{' '}
          <Typography.Text strong>{requestJobPostingName}</Typography.Text>
        </Typography.Text>
      }
      okText={t('OK')}
      cancelText={t('Cancelar')}
      {...props}
    >
      <Typography.Paragraph>
        <Trans values={{ requestJobPostingName }}>
          Ao reprovar a requisição{' '}
          <Typography.Text strong>{{ requestJobPostingName }}</Typography.Text>, ela será finalizada
          de forma permanente e não poderá ser retomada. Deseja continuar?
        </Trans>
      </Typography.Paragraph>
    </Modal>
  );
};

export default ConfirmRequestJobPostingRejectModal;
